<template>
  <div>
    <v-bottom-navigation
      color="info"
      horizontal
      :background-color="colorfrist"
      dark
    >
      <v-btn to="/admin/timelines/transfer_govem">
        <span>กำหนดการ </span>
        <v-icon>mdi-numeric-0-box</v-icon>
      </v-btn>

      <v-btn to="/admin/man_power_govem">
        <span>ข้อมูลอัตรา</span>
        <v-icon>mdi-source-branch</v-icon>
      </v-btn>

      <v-btn to="/admin/government_employee_report">
        <span>รายงานตำแหน่งว่าง </span>
        <v-icon>mdi-source-branch</v-icon>
      </v-btn>

      <v-btn to="/admin/college_manpower_govem">
        <span>รายละเอียดตำแหน่งว่าง</span>
        <v-icon>mdi-source-branch</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <v-bottom-navigation
      color="info"
      horizontal
      :background-color="colorsecord"
      dark
    >
      <v-btn to="/admin/gov_em/transference_location_detail">
        <span>รายละเอียดผู้ยืนย้าย ประกอบพิจารณา </span>
        <v-icon>mdi-details</v-icon>
      </v-btn>
      <v-btn to="/admin/gov_em/transference_location">
        <span>รายละเอียดผู้ยืนย้าย </span>
        <v-icon>mdi-details</v-icon>
      </v-btn>

      <v-btn to="/admin/gov_em/transference_personnel">
        <span>ประมวลผล 1 </span>
        <v-icon>mdi-calculator</v-icon>
      </v-btn>

      <v-btn to="/admin/gov_em/process_transfer">
        <span>ประมวลผล 2 [ระบบ]</span>
        <v-icon>mdi-calculator</v-icon>
      </v-btn>

      <v-btn to="/admin/gov_em/process_transfer_switch_normal">
        <span>ประมวลผล 3 [สับเปลี่ยน ปกติ]</span>
        <v-icon>mdi-calculator</v-icon>
      </v-btn>

      <v-btn to="/admin/gov_em/process_transfer_switch">
        <span>ประมวลผล 4 [สับเปลี่ยน ระบบ]</span>
        <v-icon>mdi-calculator</v-icon>
      </v-btn>

      <v-btn to="/admin/gov_em/conditons_transfer_success">
        <span>สรุปผล</span>
        <v-icon>mdi-bookmark-check</v-icon>
      </v-btn>

      <v-btn to="/admin/gov_em/Order_appoint">
        <span>รายงาน</span>
        <v-icon>mdi-printer</v-icon>
      </v-btn>
      <v-btn to="/admin/gov_em/conditons_transfer_success_reportmv">
        <span>รายงานตัว</span>
        <v-icon>mdi-account-check</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
export default {
  name: "HRvecMovementmenu",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
  computed: {
    colorfrist() {
      return "#8F17B0FF";
    },
    colorsecord() {
      return "#280606FF";
    }
  }
};
</script>

<style lang="scss" scoped></style>
